import { render, staticRenderFns } from "./p-check-data.vue?vue&type=template&id=5576918a&scoped=true"
import script from "./p-check-data.vue?vue&type=script&lang=js"
export * from "./p-check-data.vue?vue&type=script&lang=js"
import style0 from "./p-check-data.vue?vue&type=style&index=0&id=5576918a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5576918a",
  null
  
)

export default component.exports